import { render, staticRenderFns } from "./ImportLoadData.vue?vue&type=template&id=6d96efb1&scoped=true&"
import script from "./ImportLoadData.vue?vue&type=script&lang=js&"
export * from "./ImportLoadData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d96efb1",
  null
  
)

export default component.exports